import { render, staticRenderFns } from "./IssueModal.vue?vue&type=template&id=7def90e3&"
import script from "./IssueModal.vue?vue&type=script&lang=ts&"
export * from "./IssueModal.vue?vue&type=script&lang=ts&"
import style0 from "./IssueModal.vue?vue&type=style&index=0&id=7def90e3&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports